import { render, staticRenderFns } from "./PurchaseSupplier.vue?vue&type=template&id=49479aca&scoped=true&"
import script from "./PurchaseSupplier.vue?vue&type=script&lang=js&"
export * from "./PurchaseSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49479aca",
  null
  
)

export default component.exports